import { useEffect } from "react"
import { useNavigate } from "react-router-dom"

import { Button } from "@/components/ui/button"
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card"
import logo from "@/assets/logo.png"
import abayeLogo from "@/assets/abaye.png"
import { useSession } from "@/lib/useSession"

export function LoginPage() {
  const user = useSession()
  const navigate = useNavigate()

  useEffect(() => {
    if (user) navigate("/", { replace: true })
  }, [user, navigate])

  return (
    <div className="flex min-h-svh flex-col items-center justify-center gap-6 bg-background p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="items-center text-center">
          {/* הלוגו כהה על רקע שקוף - בערכת הכהה מציבים אותו על שבב לבן כדי שיישאר קריא */}
          <img
            src={logo}
            alt="מזלט - מתנה בקליק"
            className="mb-3 h-24 w-auto object-contain dark:rounded-xl dark:bg-white dark:p-2"
          />
          <CardTitle className="text-xl">ניהול עמדות מרוחקות</CardTitle>
          <CardDescription>
            מערכת ניהול מרחוק של טאבלטים
          </CardDescription>
        </CardHeader>
        <CardContent>
          <Button asChild className="w-full" size="lg">
            <a href="/auth/google">
              <GoogleIcon />
              התחבר עם Google
            </a>
          </Button>
        </CardContent>
      </Card>

      <a
        href="https://abaye.co"
        target="_blank"
        rel="noreferrer"
        className="group flex items-center gap-2 text-xs text-muted-foreground transition-colors hover:text-foreground"
      >
        <img
          src={abayeLogo}
          alt=""
          className="size-7 rounded-full border object-contain opacity-80 transition-opacity group-hover:opacity-100"
        />
        <span>
          פותח על ידי <span className="font-medium">Abaye</span> · abaye.co
        </span>
      </a>
    </div>
  )
}

function GoogleIcon() {
  return (
    <svg viewBox="0 0 18 18" className="size-4" aria-hidden="true">
      <path
        fill="#4285F4"
        d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844a4.14 4.14 0 0 1-1.796 2.716v2.255h2.908c1.702-1.567 2.684-3.874 2.684-6.612Z"
      />
      <path
        fill="#34A853"
        d="M9 18c2.43 0 4.467-.806 5.956-2.184l-2.908-2.255c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 0 0 9 18Z"
      />
      <path
        fill="#FBBC05"
        d="M3.964 10.71A5.41 5.41 0 0 1 3.682 9c0-.593.102-1.17.282-1.71V4.958H.957A8.997 8.997 0 0 0 0 9c0 1.452.348 2.827.957 4.042l3.007-2.332Z"
      />
      <path
        fill="#EA4335"
        d="M9 3.579c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0 5.482 0 2.438 2.017.957 4.958L3.964 7.29C4.672 5.163 6.656 3.579 9 3.579Z"
      />
    </svg>
  )
}
